import { render, staticRenderFns } from "./GriSbLinkedTable.vue?vue&type=template&id=786d80e8"
import script from "./GriSbLinkedTable.vue?vue&type=script&lang=js"
export * from "./GriSbLinkedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports